import { APP_TEXT } from '../config/app.text';

/** 아직 그릴 것이 없을 때의 빈 화면(부팅 중 · 첫 라우트 모듈을 불러오는 중). */
export function RouteLoading() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={APP_TEXT.booting}
      className="min-h-screen bg-bg-surface"
    />
  );
}
